<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form ref="formValidate" :inline="true" :model="params">
        <el-form-item :label="$t('common.startTime')" prop="time_start">
          <el-date-picker
            style="width: 150px"
            v-model="params.time_start"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('common.startTimePla')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('common.endTime')" prop="time_end">
          <el-date-picker
            style="width: 150px"
            v-model="params.time_end"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('common.endTimePla')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('operatorLog.account')" prop="userName">
          <el-input
            style="width: 150px"
            v-model.trim="params.userName"
            :placeholder="$t('common.userNamePla')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('operatorLog.logName')" prop="logname">
          <el-input
            v-model.trim="params.logname"
            style="width: 150px"
            :placeholder="$t('common.logNamePla')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('common.logType')" prop="type">
          <zk-dictionary-select
            style="width: 150px"
            type="operatorLog"
            v-model="params.type"
          ></zk-dictionary-select>
        </el-form-item>
        <el-button type="primary" @click="query" icon="el-icon-search">{{
          $t('common.search')
        }}</el-button>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @remove="remove"></zk-tool-bar>
      </div>
      <el-table
        ref="multipleTable"
        :data="logData"
        style="width: 100%"
        :highlight-current-row="true"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        @selection-change="selected"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="type" :label="this.$t('common.logType')">
          <template slot-scope="scope">
            <zk-dictionary-transform
              :key="scope.row.id"
              type="operatorLog"
              :value="scope.row.type"
            ></zk-dictionary-transform>
          </template>
        </el-table-column>
        <el-table-column
          prop="logname"
          :label="this.$t('operatorLog.logName')"
        ></el-table-column>
        <el-table-column
          prop="userName"
          :label="this.$t('operatorLog.account')"
        ></el-table-column>
        <el-table-column
          prop="result"
          :label="this.$t('operatorLog.result')"
        ></el-table-column>
        <el-table-column
          prop="costTime"
          :label="this.$t('operatorLog.costTime')"
        ></el-table-column>
        <el-table-column prop="time" :label="this.$t('operatorLog.time')">
          <template slot-scope="scope">
            <span>{{ scope.row.time | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <span
              class="btn-text-cla"
              @click.stop="toggleRowExpansion(scope.row)"
            >
              {{ $t('common.details') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>

      <el-drawer :visible.sync="drawer" :with-header="false">
        <div class="operatorLog-details-cla" v-if="currentRow">
          <div class="item-detail-cla">
            <lable>{{ $t('operatorLog.className') }}:</lable>
            <div>{{ currentRow.className }}</div>
          </div>
          <div class="item-detail-cla">
            <lable>{{ $t('operatorLog.methodName') }}:</lable>
            <div>{{ currentRow.methodName }}</div>
          </div>
          <div class="item-detail-cla">
            <lable>{{ $t('operatorLog.msg') }}:</lable>
            <div>
              <json-viewer
                :expand-depth="10"
                class="associatedLog_json_cla"
                v-if="currentRow.msg !== ''"
                :value="convertToJson(currentRow.msg)"
              ></json-viewer>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import * as operateLog from '../../../services/operateLog.js'
import { isEmpty } from '../../../utils/index.js'
import { dateFormat, getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import JsonViewer from 'vue-json-viewer'
export default {
  name: 'ZkOperatorLog',

  data() {
    let dataRange = getCurrentDateStartAndEndTime()
    let params = {
      time_start: dataRange[0].getTime(),
      time_end: dataRange[1].getTime(),
      type: '',
      logname: '',
      userName: ''
    }
    let typeList = [
      {
        value: '4',
        label: this.$t('operatorLog.operatorLog')
      },
      {
        value: '5',
        label: this.$t('operatorLog.exceptionLog')
      }
    ]
    let logIdList = []
    return {
      // columnData,
      logData: [],
      typeList,
      drawer: false,
      currentRow: {},
      modal: false,
      id: '',
      index: '',
      params,
      logIdList,
      returnValue1: '',
      expands: []
    }
  },
  components: { JsonViewer },
  methods: {
    getRowKeys(row) {
      return row.id
    },
    toggleRowExpansion(row) {
      this.drawer = true
      this.currentRow = row
    },
    convertToJson(str) {
      try {
        let obj = JSON.parse(str)
        if (typeof obj === 'object') {
          return JSON.parse(str, (key, value) => {
            if (key === 'eventTime') {
              return dateFormat(new Date(value))
            }
            if (value instanceof Array) {
              return value
            }
            return this.convertToJson(value)
          })
        } else {
          return str
        }
      } catch (error) {
        return str
      }
    },
    query() {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery() {
      if (
        !isEmpty(this.params.time_start) &&
        this.params.time_start instanceof Date
      ) {
        this.params.time_start.setMilliseconds(0)
        this.params.time_start = this.params.time_start.getTime()
      }
      if (
        !isEmpty(this.params.time_end) &&
        this.params.time_end instanceof Date
      ) {
        this.params.time_end.setMilliseconds(999)
        this.params.time_end = this.params.time_end.getTime()
      }
      operateLog
        .query({
          params: this.params,
          pager: this.pager
        })
        .then(data => {
          if (data.code === '00000000') {
            this.logData = data.payload.results.results || data.payload.results
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          }
        })
        .catch(data => {})
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    confirmDelete() {
      let params = {
        ids: this.logIdList
      }
      operateLog
        .remove(params)
        .then(data => {
          if (data.code === '00000000') {
            this.query()
            this.$message({
              type: 'info',
              message: this.$t('common.successDelete')
            })
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
        .catch(data => {
          this.$message({
            type: 'error',
            message: data.message
          })
        })
    },
    selected(selection) {
      this.logIdList = []
      if (selection.length > 0) {
        selection.forEach(item => {
          this.logIdList.push(item.id)
        })
      }
    },
    remove() {
      if (this.logIdList.length > 0) {
        this.$confirm(
          this.$t('common.confirmDeleteRecordTip'),
          this.$t('common.confirmDelete'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            this.confirmDelete()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('common.cancelDelete')
            })
          })
      } else {
        this.$message({
          message: this.$t('common.select1record'),
          type: 'warning'
        })
      }
    }
  },
  mounted() {
    this.query()
  }
}
</script>

<style scoped lang="less">
.arrow_icon {
  position: absolute;
  top: -20px;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #a99e9e transparent;
}
.arrow_icon2 {
  position: absolute;
  top: -18px;
  z-index: 1000;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #eceaea transparent;
}

.operatorLog-details-cla {
  padding: 15px;
  .item-detail-cla {
    // lable{
    //   padding-right: 20px;
    // }
    padding: 10px 0px;
    border-bottom: 1px solid #dedcda;
  }
}

.name-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/operatorLog/src/main.vue